import "./style.scss";
import { AlertColor } from "@mui/material/Alert";
import { BrowserRouter } from "react-router-dom";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { useState } from "react";
import Alert from "components/utils/alert";
import AlertContext from "context/alert.context";
import Loader from "components/utils/loader";
import LoaderContext from "context/loader.context";
import Router from "Router";

export default function App() {
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [severity, setSeverity] = useState<AlertColor>("success");

  return (
    <ThemeProvider
      theme={createTheme({
        typography: {
          fontFamily: "Arial",
        },
      })}
    >
      <AlertContext.Provider
        value={[message, setMessage, severity, setSeverity, open, setOpen]}
      >
        <LoaderContext.Provider value={[loading, setLoading]}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
          <Alert
            message={message}
            severity={severity}
            open={open}
            setOpen={setOpen}
          />
          <Loader loading={loading} />
        </LoaderContext.Provider>
      </AlertContext.Provider>
    </ThemeProvider>
  );
}
